import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ElasticSearchService } from 'src/app/shared/services/elastic-search.service';
import { SponsorshipsService } from 'src/app/shared/services/sponsorships.service';
import { SponsorshipRequestService } from 'src/app/shared/services/sponsorship-request.service';

import { UpserviceService } from 'src/app/shared/services/upservice.service';
import { Auth } from 'aws-amplify';

@Component({
  selector: 'app-add-sponsorship-requests',
  templateUrl: './add-sponsorship-requests.component.html',
  styleUrls: ['./add-sponsorship-requests.component.css'],
  styles: [
    `
      :host ::ng-deep button {
        margin-right: 0.25em;
      }
    `,
  ],
  providers: [UpserviceService,],
})
export class AddSponsorshipRequestsComponent implements OnInit {
  addSponsorshipRequestForm: FormGroup;
  customStylesValidated = false;
  searchIcon = 'cilSearch';
  isLoading: boolean = false;
  display: boolean = false;
  isSearchingProperties: boolean = false;
  propertiesResults: boolean = false;
  propertiesSearchResults: any = [];

  isSearchingSponsors: boolean = false;
  sponsorsResults: boolean = false;
  sponsorsSearchResults: any = [];

  selectedProperty: any = {};
  selectedSponsor: any = {};
  displaySelectedProperty: boolean = false;
  propertySearchError: boolean = false;
  sponsorsSearchError: boolean = false;
  displaySelectedSponsor: boolean = false;
  propertyValid: boolean = false;
  sponsorValid: boolean = false;
  owner: any;
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private sponsorshipsService: SponsorshipsService,
    private elasticSearchService: ElasticSearchService,
    private sponsorshipRequestsService: SponsorshipRequestService,
    private upService: UpserviceService
  ) {
    this.getCurrentAuthenticatedUser();
    this.addSponsorshipRequestForm = this.fb.group({
      sponsorName: [''],
      propertyName: [''],
      name: [''],
      value: [''],
      type: [''],
      submissionDate: [''],
    });
  }

  ngOnInit(): void { }

  getCurrentAuthenticatedUser() {
    // this.showMenu = false;
    Auth.currentAuthenticatedUser()
      .then((user) => {
        console.log(user.attributes.email);
        this.owner = user.attributes.email;
      },
        (error) => {
          console.log("authentication error", error);
          // this.userNotAuthenticated = error; 

          // this.isHidden = true;
        });
  }

  onAddSponsorshipRequest() {
    this.customStylesValidated = true;

    if (Object.keys(this.selectedProperty).length) this.propertyValid = true;
    else this.propertyValid = false;

    if (Object.keys(this.selectedSponsor).length) this.sponsorValid = true;
    else this.sponsorValid = false;

    console.log('propertyValid: ', this.propertyValid);
    console.log('sponsorValid: ', this.sponsorValid);

    if (
      this.addSponsorshipRequestForm.valid &&
      this.propertyValid &&
      this.sponsorValid
    ) {
      setTimeout(() => {
        this.isLoading = true;

        this.addSponsorshipRequestForm.value.submissionDate =
          this.convertDateToEpoch(
            this.addSponsorshipRequestForm.value.submissionDate
          );
        var sponsorshipRequest = this.addSponsorshipRequestForm.value;
        sponsorshipRequest['propertyName'] = this.selectedProperty.name;       //inject property and sponsor details
        sponsorshipRequest['propertyId'] = this.selectedProperty.propertyId;
        sponsorshipRequest['sponsorName'] = this.selectedSponsor.name;
        sponsorshipRequest['sponsorId'] = this.selectedSponsor.sponsorId;
        sponsorshipRequest['owner'] = this.owner;
        sponsorshipRequest['status'] = "NEW";

        console.log('Sponsorship request Form: ', sponsorshipRequest);

        this.sponsorshipRequestsService
          .createSponsorshipRequest(sponsorshipRequest)
          .subscribe(
            (data) => {
              this.isLoading = false;
              console.log('Data: ', data);

              setTimeout(() => {
                this.router.navigate(['/private-space/view-sporsorship-requests'], {
                  relativeTo: this.route,
                  queryParamsHandling: 'merge', // remove to replace all query params by provided
                });
              }, 2500);

            },
            (error) => {
              this.isLoading = false;
              console.log('Error: ', error);
            }
          );
      }, 500);

    } else this.display = true;
  }

  convertDateToEpoch(dateValue: string) {
    var date = new Date(dateValue);
    return date.getTime();
  }

  onSearchProperties(event: any) {
    if (event.target.value.length > 0) {
      this.isSearchingProperties = true;

      console.log('Keyup: ', event.target.value);

      this.elasticSearchService.searchProperty(event.target.value, this.owner).subscribe(
        (data) => {
          this.isSearchingProperties = false;
          this.propertiesResults = true; //display the results
          this.propertiesSearchResults = data.hits.hits;
          if (data.hits.total.value == 0) {
            this.propertySearchError = true;
          }
          console.log('Elastic Search', data);
          console.log('Search results: ', this.propertiesSearchResults);
        },
        (error) => {
          this.isSearchingProperties = false;
          console.log('Error Searching: ', error);
        }
      );
    } else {
      this.isSearchingProperties = false;
      if (Object.keys(this.selectedProperty).length === 0) {
        this.propertiesResults = false; //hide the results
      }
    }
  }

  onSearchSponsors(event: any) {
    if (event.target.value.length > 0) {
      this.isSearchingSponsors = true;

      console.log('Keyup: ', event.target.value);

      this.elasticSearchService.searchSponsor(event.target.value).subscribe(
        (data) => {
          this.isSearchingSponsors = false;
          this.sponsorsResults = true; //display the results
          this.sponsorsSearchResults = data.hits.hits;
          if (data.hits.total.value == 0) {
            this.sponsorsSearchError = true;
          }
          console.log('Elastic Search', data);
          console.log('Search results: ', this.sponsorsSearchResults);
        },
        (error) => {
          this.isSearchingSponsors = false;
          console.log('Error Searching: ', error);
        }
      );
    } else {
      this.isSearchingSponsors = false;
      if (Object.keys(this.selectedSponsor).length === 0) {
        this.sponsorsResults = false; //hide the results
      }
    }
  }

  onSelectProperty(property: any, propertyId: any) {
    this.propertiesSearchResults = []; //hide the results
    property['propertyId'] = propertyId;
    console.log('selected Property: ', property);
    this.selectedProperty = property;
    this.displaySelectedProperty = true;

    this.addSponsorshipRequestForm.patchValue({
      propertyName: property.name
    });
  }

  onSelectSponsor(sponsor: any, sponsorId: any) {
    this.sponsorsSearchResults = []; //hide the results
    sponsor['sponsorId'] = sponsorId;
    console.log('selected Sponsor: ', sponsor);
    this.selectedSponsor = sponsor;
    this.displaySelectedSponsor = true;

    this.addSponsorshipRequestForm.patchValue({
      sponsorName: sponsor.name
    });
  }

  onReset() { }

  removeProperty() {
    this.selectedProperty = {};
    this.propertiesResults = false;
    this.displaySelectedProperty = false;
  }

  removeSponsor() {
    this.selectedSponsor = {};
    this.sponsorsResults = false;
    this.displaySelectedSponsor = false;
  }
}
